import { AssetEvent } from './asset.event';
import { EventRegistry } from '../../../../../domain/event/event.registry';
export class AssetPurgedEvent extends AssetEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `asset-class/${payload.assetClassId}/asset/${payload.id}`,
            type: AssetPurgedEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
AssetPurgedEvent.type = 'com.treeplotter.api.asset.purged.v1';
EventRegistry.register(AssetPurgedEvent.type, AssetPurgedEvent);
//# sourceMappingURL=asset-purged.event.js.map